import * as React from "react";
import { DocumentCard } from "./DocumentCard";

type DocumentStatus = "draft" | "published" | "archived";

type Document = {
  _id: string;
  title: string;
  summary?: string;
  status: DocumentStatus;
  updatedAt: number;
  contentPreview?: string;
  tags?: string[];
};

type Subfolder = {
  path: string;
  name: string;
  documentCount: number;
};

type DocumentGridProps = {
  documents: Document[];
  subfolders: Subfolder[];
  onDocumentClick: (documentId: string) => void;
  onFolderClick: (folderPath: string) => void;
  selectedDocumentIds?: Set<string>;
  onDocumentSelectionChange?: (documentId: string, selected: boolean) => void;
};

export function DocumentGrid({
  documents,
  subfolders,
  onDocumentClick,
  onFolderClick,
  selectedDocumentIds,
  onDocumentSelectionChange,
}: DocumentGridProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {subfolders.map((folder) => (
        <DocumentCard
          key={folder.path}
          type="folder"
          title={folder.name}
          documentCount={folder.documentCount}
          onClick={() => onFolderClick(folder.path)}
          onDoubleClick={() => onFolderClick(folder.path)}
        />
      ))}
      {documents.map((doc) => (
        <DocumentCard
          key={doc._id}
          type="document"
          title={doc.title}
          summary={doc.summary}
          status={doc.status}
          updatedAt={doc.updatedAt}
          contentPreview={doc.contentPreview}
          tags={doc.tags}
          onClick={() => onDocumentClick(doc._id)}
          onDoubleClick={() => onDocumentClick(doc._id)}
          documentId={doc._id}
          isSelected={selectedDocumentIds?.has(doc._id)}
          onSelectionChange={
            onDocumentSelectionChange
              ? (selected) => onDocumentSelectionChange(doc._id, selected)
              : undefined
          }
        />
      ))}
    </div>
  );
}
